<template>
  <div style="margin: 10px">
      <v-card>
        <div class="headline dialog-header">
          <v-toolbar color="primary" dark>
            <v-toolbar-title style="padding-left: 10px"
            >Export học sinh bởi danh sách lớp
            </v-toolbar-title>
          </v-toolbar>
        </div>
        <v-form id="createForm" @keyup.enter.native="onSave" v-model="formValid" lazy-validation ref="createForm">
          <v-layout wrap>
            <v-flex xs12 style="padding: 10px">
              <i-upload label="File export học sinh bởi lớp" name="attachId" id="attachId"

                        v-model="values['attachId']"/>
            </v-flex>
          </v-layout>
        </v-form>
        <div style="text-align: right">
          <v-btn color="primary" @click="onDownload">
            Tải xuống file mẫu
          </v-btn>
          <v-btn color="primary" @click="onSave">
            <v-icon dark left>save</v-icon>
            {{$t('lang.common.save')}}
          </v-btn>
        </div>
      </v-card>
  </div>
</template>

<script>
import Validator from "../../../../public/js/validator";
import axios from "axios";
import {message} from "@/shared/message";
import IUpload from "../../../components/form/Upload";


const v = Validator();
console.log("---v---");
console.log(v);

export default {
  name: 'customer-create',
  components: {IUpload, Validator, },
  inheritAttrs: true,
  props: {
    enableDelete: {
      type: Boolean,
      default: false
    },
    createFormName: {
      type: String,
      default: 'Import học sinh'
    },
    inputItems: {
      type: Array,
      default: () => []
    },
    createUrl: {
      type: String,
      default: "/babiExport/exportAccountClass/"
    },
    deleteUrl: {
      type: String,
      default: ""
    },
    column: {
      type: String,
      default: "12"
    },
    defaultData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data: () => {
    return {
      formValid: false,
      values: {},
      model: {},
      subject: {},
      subjects: [],
      attachId: null,
      attachType: null,
    }
  },
  watch: {
    defaultData: function (value) {
      console.log("defaultData 999", this.value);
      this.values = this.copyValue(value);
    },
    formValid : function(value){
      console.log("formValid", this.formValid);
    }
  },
  methods: {
    copyValue: function (value) {
      console.log("copy function");
      let ob = {};
      for (let key in value) {
        ob[key] = value[key];
      }
      return ob;
    },
    onSave: function () {
      this.$validator.validate().then(
          axios({
            url: process.env.VUE_APP_API_URL + this.createUrl,
            method: "POST",
            data: this.values,
            responseType: "blob", // important
          }).then(response => {
            console.log(response)
            if (response) {
              const url = window.URL.createObjectURL(new Blob([response]));
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", "Result_Export_AccountClass" + ".xlsx");


              document.body.appendChild(link);
              link.click();
              link.remove();
              window.URL.revokeObjectURL(url);
            }
          })

      )
    },
    onDownload: function (){
      axios({
        url: process.env.VUE_APP_API_URL + "/import/download/7",
        method: "POST",
        data: this.values,
        responseType: "blob", // important
      }).then(response => {
        if (response) {
          const url = window.URL.createObjectURL(new Blob([response]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "Template_Export_AccountClass" + ".xlsx");

          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
        }
      });
    },

    onView: function (value) {

      this.values = value;
      //this.formValid = true;
      this.subject = null;
      for (let i = 0; i < this.subjects.length; i++) {
        if (this.subjects[i].categoryId == value.parentId) {
          this.subject = this.subjects[i];
          break;
        }
      }
      this.$refs.createForm.resetValidation();
    }
    ,

    onDelete: function () {
      if (confirm(this.$t("lang.common.deleteConfirm"))) {
        axios.post(process.env.VUE_APP_API_URL + this.deleteUrl, this.values).then(data => {
          message.success(this.$t("lang.common.delete_success"));
          this.$emit("cancel");
        }, error => {
          message.error(this.$t("lang.common.deleteError"));
        });
      }
      ;
    }
    ,

    onCancel: function () {
      this.$emit("close")
      this.$parent.onSearch();
      this.$router.push({ path: '/import/importlist', query: this.$route.query });
      // try {
      //     if (document.getElementById("searchDiv") != null)
      //         document.getElementById("searchDiv").style.display = "";
      //     if (document.getElementById("createDiv") != null)
      //         document.getElementById("createDiv").style.display = "none";
      //     console.log(this.$parent);
      //     this.$parent.onSearch();
      // } catch (e) {
      //     console.log(e);
      // }
      // this.$emit("cancel");
    }
    ,

    onChangeSubject: function (data) {
      console.log(data);
      this.values['parentId'] = data.categoryId;
      this.values['parentName'] = data.categoryName;
      console.log(this.values);
    },
    uploadNewFile: function (data) {

      let md = {
        url: process.env.VUE_APP_API_URL + "/download/attach/" + data.id,
        attachId: data.id,
        type: data.type,
        fileName: data.fileName
      }
      this.attachId = data.id;
      this.attachType = data.type;
      if (this.attachs == null) {
        this.attachs = [md];
      } else {
        this.attachs.push(md);
      }
    },
  },

  created() {
    console.log(this.values);

    // axios.post(process.env.VUE_APP_API_URL + "/category/listByType?type=SUBJECT").then(
    //     data => {
    //         this.subjects = data;
    //     },
    //     error => {
    //         console.log(error);
    //     }
    // )
  },


}
</script>
